import { createSelector } from 'reselect';
import { dynamicBottomNavSelector } from 'selectors/testTarget/offers/dynamicBottomNav/dynamicBottomNavSelector';

const showSelector = createSelector(dynamicBottomNavSelector, dynamicBottomNav => !!dynamicBottomNav.show);

export { showSelector };
